import React, { useEffect, useRef } from 'react';
import { mountResultsChain } from './resultsChainData';
import './ResultsChainPage.css';

export default function ResultsChainPage() {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) mountResultsChain(ref.current);
  }, []);

  return <div className="rc-root" ref={ref} />;
}
